import { AxiosResponse } from 'axios';
import { customerUsersApi } from '../../api';

export async function deleteCustomerUser(id: string): Promise<AxiosResponse> {
  const response = await customerUsersApi.delete(`/${id}`);
  return response;
}
